<module-container>
  <div class="title-container">
    <h2>Client Configuration</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
